import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { LOADING_STATUSES } from '@yandex-int/k-common/client/api/constants';

import type { Student } from 'common.components/typings';

import type { ExamsResultsStoreState, ExamResult, ID_YEAR_EXAMTYPE, ExamResultsTemplate } from './typings';

const initialState: ExamsResultsStoreState = {
    loadingStatus: LOADING_STATUSES.UNSENT,
    savingResultsStatus: LOADING_STATUSES.UNSENT,
    resultsTemplate: {},
    errorId: undefined,
};

/* eslint-disable @typescript-eslint/no-unused-vars */
const slice = createSlice({
    name: 'EXAMS_RESULTS',
    initialState,
    reducers: {
        getListExamsResultsRequest: (state, action: PayloadAction<{ teamId: number }>) => {
            state.loadingStatus = LOADING_STATUSES.LOADING;
            state.errorId = undefined;
            //saga
        },
        getListExamsResultsSuccess: (state, action: PayloadAction<{ students: Student[]; results: ExamResult[] }>) => {
            const { students, results } = action.payload;

            state.loadingStatus = LOADING_STATUSES.SUCCESS;

            state.resultsTemplate = {};
            results.forEach((result) => {
                if (students.some(({ id }) => id === result.student_id)) {
                    state.resultsTemplate[`${result.student_id}_${result.year}_${result.exam_type}`] = result;
                }
            });
        },

        updateField: (
            state,
            action: PayloadAction<{ id: ID_YEAR_EXAMTYPE; points?: number | string; score?: number | string }>
        ) => {
            const { id, points, score } = action.payload;

            const [studentId, year, examType] = id.split('_');
            state.resultsTemplate[id] = {
                student_id: Number(studentId),
                year: Number(year),
                exam_type: examType,
                points: points ?? (state.resultsTemplate[id]?.points || ''),
                score: score ?? (state.resultsTemplate[id]?.score || ''),
            };
        },

        postExamsResultsRequest: (state, action: PayloadAction<{ teamId: number; results: ExamResultsTemplate }>) => {
            state.savingResultsStatus = LOADING_STATUSES.LOADING;
            state.errorId = undefined;
            // saga
        },
        postExamsResultsSuccess: (state) => {
            state.savingResultsStatus = LOADING_STATUSES.SUCCESS;
        },
        postExamsResultsError: (state, action: PayloadAction<string>) => {
            state.savingResultsStatus = LOADING_STATUSES.ERROR;
            state.errorId = action.payload;
        },
    },
});
/* eslint-enable @typescript-eslint/no-unused-vars */

export const { actions, reducer } = slice;
